import React, {useState} from 'react';

import {CopyButton} from 'src/components/copy-button/copy-button';

import Button, {FlatButton} from '@pb/kit-component-button';
import {Dialog, DialogFooter, DialogHeader, DialogHole} from '@pb/kit-component-dialog-v2';
import Group, {Item} from '@pb/kit-component-group';
import {Icons, Sizes} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {Loading, Types} from '@pb/kit-component-loading';

type Props = {
    eventCode: string,
    setEventCode: (eventCode: string) => void,
    onGenerating: boolean,
    onGenerateClick: () => void,
    onEventCodeGenerate?: (eventCode: string) => void,
};

const EVENT_CODE_PLACEHOLDER = 'Click the button below to generate an event code for the event.';

export const EventCodeGenerationView = (props: Props) => {
    const {
        eventCode,
        setEventCode,
        onGenerating,
        onGenerateClick,
        onEventCodeGenerate,
    } = props;

    const [shown, setShown] = useState(false);

    const onClose = () => {
        setEventCode('');
        setShown(false);
    };

    const onApply = () => {
        if (onEventCodeGenerate) {
            onEventCodeGenerate(eventCode);
            setShown(false);
        }
    };

    return (
        <Dialog
            setShown={setShown}
            shown={Boolean(shown)}
            anchor={({anchorRef, getAnchorProps}) => (
                <BasicIconButton
                    className="event-code-generation-tour"
                    ref={anchorRef}
                    {...getAnchorProps()}
                    iconProps={{type: Icons.SPARKLES, size: Sizes.Size_16}}
                />
            )}>
            <Group direction="v" justify="space-between" className="pb-m" style={{minWidth: 500}}>
                <DialogHeader onClose={onClose}>AI Assistant</DialogHeader>
                <DialogHole>
                    <Group direction="v" gap="m">
                        <Group>
                            <Item><strong>Generated Event Code:</strong></Item>
                            {onGenerating ? (
                                <Loading fast={true} type={Types.ICON}/>
                            ) : null}
                        </Group>
                        <Item style={{minHeight: '3rem'}}>
                            {eventCode ? (
                                <Group>
                                    <Item>{eventCode}</Item>
                                    <CopyButton textToCopy={eventCode} size={Sizes.Size_12}/>
                                </Group>
                            ) : (
                                <Item>{EVENT_CODE_PLACEHOLDER}</Item>
                            )}
                        </Item>
                    </Group>
                    <Group justify="end">
                        {onEventCodeGenerate ? (
                            <FlatButton disabled={!eventCode || onGenerating} onClick={onApply}>Apply</FlatButton>
                        ) : null}
                    </Group>
                </DialogHole>
                <DialogFooter>
                    <Button style={{width: '100%'}} variant="Type.SECONDARY" onClick={onGenerateClick}>
                        Generate Event Code
                    </Button>
                </DialogFooter>
            </Group>
        </Dialog>
    );
};
